module.exports = __webpack_public_path__ + "static/media/MENU_PARAMETROS.a1d545b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MENU_PARAMETROS.svg
// module id = 494
// module chunks = 0